import React from 'react';
import { Box } from '@mui/material';

interface Props {
  children: React.ReactNode;
  direction?: 'row' | 'column';
}
const FlexContainer = ({ children, direction }: Props): JSX.Element => {
  return (
    <Box sx={{ display: 'flex', px: 4, py: 2 }} style={{ flexDirection: direction ? direction : 'column' }}>
      {children}
    </Box>
  );
};

export default FlexContainer;
